import { Utilities } from "../../utils/Utilities";

/** Base type for all typescript enums */
export type BaseEnum = { [key: string]: string | number };

export type MappedEnum = Array<{ label: string, value: string | number, title: string }>;

export interface EnumOptions {
    /** Override auto generated label. */
    labels?: { [value in string | number]: string },
    /** Enum values to be hidden. */
    hidden?: (string | number)[],
    /** Enum values to be shown. */
    visible?: (string | number)[],
    /** Default is true */
    splitCamelCase?: boolean | { joinChar?: string },
    /** Default is number */
    valueType?: "number" | "string",
    order?: (string | number)[]
}

export function getMappedEnum(baseEnum: BaseEnum, options?: EnumOptions) {
    const mappedEnum: MappedEnum = [];
    const labels = options?.labels ?? {};
    const hidden = options?.hidden ?? [];
    const visible = options?.visible;
    const split = (options?.splitCamelCase ?? true);
    const joinChar = (typeof split !== 'boolean') ? split.joinChar : undefined
    const valueType = options?.valueType ?? "number";
    const order = options?.order;

    Object.keys(baseEnum)
        .forEach((key, index) => {
            const value = valueType === 'string' ? key : Number(key);
            if (!hidden.includes(value) && !hidden.includes(key) &&
                (!visible || visible.includes(value) || visible.includes(key)) &&
                (typeof value === 'string' || !isNaN(value)))
            {
                let label = `${baseEnum[value]}`;
                if (labels[value] || !!split)
                    label = labels[value] ?? Utilities.splitCamelCase(label, joinChar);
                mappedEnum.push({ value, label, title: "" });                
            }
        })

    if (order?.length) {
        mappedEnum.sort((a, b) => {
            return order.indexOf(a.value) - order.indexOf(b.value);
        })
    }
    else {
        mappedEnum.sort((a, b) => {
            const a_val = a.value;
            const b_val = b.value;            
            if (typeof a_val === "number" && typeof b_val === "number")
                return a_val - b_val;
            else if (typeof a_val === "string" && typeof b_val === "string")
                return a_val.localeCompare(b_val);            
            return 0;
        })
    }


    return mappedEnum;
}